// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"771e1fed","703":"4276d7c4","787":"1df2a859"}[chunkId] + ".chunk.js";
};